/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import mimetics from "mimetics";
import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import styled from "styled-components";

import { ordersService } from "_services";

import { SpinnerBlock } from "widget/Spinner";

import { ReactComponent as FolderIcon } from "assets/img/Folder.svg";
import { ReactComponent as FileIcon } from "assets/img/File.svg";
import { ReactComponent as DownloadSVG } from "assets/img/Download.svg";

const StyledCard = styled(Card)`
  width: 160px;
  height: 200px;
  overflow: hidden;
`;

const CardContent = styled.div`
  height: 70%;
  width: 100%;

  & img {
    width: 100%;
    height: 100%;
    scale: 0.96;
    border-radius: 0.25rem;
    box-shadow: 0 0 5px lightgray inset;
    object-fit: scale-down;
    background-color: #f0f0f0;
    vertical-align: bottom;
  }
`;

const IconContainer = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  color: gray;

  & #unable-preview-icon,
  & #folder-icon {
    /* padding: 24px; */
    width: 100%;
    height: 90%;
    object-fit: cover;
    color: gray;
  }
`;

const CardFooter = styled.div`
  display: flex;

  /* text-align: center; */
  border-top: 1px solid lightgray;
  height: 30%;
  width: 100%;
  padding: 0 5px;

  & #concept-download-icon {
    height: 100%;
    width: 80%;
    /* padding: 7px 0; */
    cursor: pointer;
  }

  & .card-footer-left {
    display: flex;
    justify-content: center;
    align-items: start;
    flex: 2;
  }

  & .card-footer-right {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 10;
    text-transform: capitalize;
    color: #7b848d;
    text-align: center;
    font-size: 13px;
    font-family: "Montserrat";
  }
`;

const LogoCard = (props) => {
  const { index, orderId, productId, fileType, handleDownload } = props;

  const [blob, setBlob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLogoConcept, setIsLogoConcept] = useState(true);

  useEffect(() => {
    let ignore = false;

    if (fileType.includes("LOGO_CONCEPT")) {
      ordersService.getBlobFileFromProduct(orderId, productId, fileType).then((response) => {
        response
          .arrayBuffer()
          .then((buffer) => {
            let fileInfo = {};

            try {
              fileInfo = mimetics(buffer);
            } catch (error) {
              console.error("Something went wrong with file recognizing\n", error);
            }

            const blob = new Blob([buffer]);
            return { blob, fileInfo };
          })
          .then(({ blob, fileInfo }) => {
            if (!ignore) {
              if (fileInfo?.media === "image") {
                setBlob(URL.createObjectURL(blob));
              }
              setLoading(false);
            }
          });
      });
    } else {
      setLoading(false);
      setIsLogoConcept(false);
    }

    return () => {
      ignore = true;
    };
  }, []);

  return (
    <StyledCard>
      <CardContent>
        {loading && <SpinnerBlock />}
        {!loading && blob !== null && <img src={blob} />}
        {!loading && blob === null && (
          <IconContainer>
            <div style={{ width: "100%", height: "20%" }}>{isLogoConcept && "Preview is unable"}</div>
            <div style={{ width: "100%", height: "80%" }}>
              {isLogoConcept ? <FileIcon id="unable-preview-icon" /> : <FolderIcon id="folder-icon" />}
            </div>
          </IconContainer>
        )}
      </CardContent>
      <CardFooter>
        <div className="card-footer-left">
          <DownloadSVG id="concept-download-icon" onClick={() => handleDownload(props)} />
        </div>
        <div className="card-footer-right">
          {`${fileType
            .toLowerCase()
            .split("_")
            .filter((part) => !["trademark", "logo"].includes(part))
            .join(" ")} ${!isLogoConcept ? index + 1 : ""}`}
        </div>
      </CardFooter>
    </StyledCard>
  );
};

export default LogoCard;
